import {
    HealthCheckerGroup,
    HealthCheckerGroupRequest,
} from "../../../../../models/health-checker/health-checker";
import {HealthCheckerGroupFormValues} from "./check-groups.types";

export const healthCheckerGroupToFormValues = (
    group: HealthCheckerGroup | null
): HealthCheckerGroupFormValues => {
    if (!group) {
        return {
            name: "",
            members: [{notificationMethod: "none"}],
        };
    }

    return {
        name: group.name,
        members: group.members.map((member) => ({
            user: {
                key: member.user.id,
                value: member.user.email,
                label: `${member.user.firstName} ${member.user.lastName} (${member.user.email})`,
            },
            notificationMethod: member.notificationMethod,
        })),
    };
};

export const healthCheckerGroupFormToRequest = (
    values: HealthCheckerGroupFormValues
): HealthCheckerGroupRequest => ({
    name: values.name,
    members: values.members.map((member) => ({
        user: Number(member.user!.key),
        notificationMethod: member.notificationMethod,
    })),
});
